import { TQueries } from '@src/models/common';
import { IComponentChildrenProps } from '@src/models/props';
import React, { useEffect, useMemo, useState } from 'react';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import { BreakpointsContext } from './BreakpointsContext';

interface IBreakpointsProviderProps extends IComponentChildrenProps {
  formFactor?: keyof TQueries;
  /** Свойство определяющее что текущее значение formFactora будет применяться только при первоначальном рендере,
   * (чаще всего это будет использоваться для определения значения на стороне сервера)
   **/
  onlyInit?: boolean;
}

export const BreakpointsProvider: React.FC<IBreakpointsProviderProps> = ({ formFactor, onlyInit, children }) => {
  const bp = useBreakpoints();
  const [breakpoint, setBreakpoint] = useState(formFactor || bp.breakpoint);

  useEffect(() => {
    if (formFactor) {
      setBreakpoint(onlyInit ? bp.breakpoint : formFactor);
    } else {
      setBreakpoint(bp.breakpoint);
    }
  }, [bp.breakpoint, formFactor, onlyInit]);

  const value = useMemo(
    () => ({
      breakpoint,
      isMobile: breakpoint === 'MOBILE',
    }),
    [breakpoint],
  );

  return <BreakpointsContext.Provider value={value}>{children}</BreakpointsContext.Provider>;
};
